export default {
	name: "customer-documents-modal",
	props: ["heading", "modalId", "showModal", "companyId"],
	emits: ["closeModal"],
	data() {
		return {
			documents: [],
			documentsHeadings: [
				{
					text: "Date",
					field: "monthAndYear"
				}
			],
			modalHeading: null,
			modalComponentId: null,
			startDate: null,
			endDate: null,
			loading: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			selectedDocumentBatchDates: [],
		};
	},
	methods: {
		getDatesForCustomerBatchedDocuments(){
			if(this.startDate === null || this.endDate === null){
				this.showErrorMessage = true;
				this.errorMessage = "Please select a date range";
				return;
			}
			this.loading = true;
			let request = {
				companyId: this.companyId,
				insertedOnFromDate: this.startDate,
				insertedOnToDate: this.endDate
			};
			orderService.getMonthlyBatchedDocumentsByCompanyId(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess) {
						if(successResponse.data.datesAreInvalid){
							this.showErrorMessage = true;
							this.errorMessage = successResponse.data.errorMessage;
						}
						else{
							this.documents = successResponse.data.result;
						}
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				});
		},
		onDocumentDateSelected(){
			this.selectedDocumentBatchDates = this.documents.filter((doc) => doc.isSelected === true);
			console.log("selectedDocumentBatchDates", this.selectedDocumentBatchDates);
		},
		onDatePickerRangeClearClick(){
			this.startDate = null;
			this.endDate = null;
		},
		onFromDateSelect(date){
			this.startDate = date;
			if(this.endDate !== null && this.endDate !== ""){
				this.getDatesForCustomerBatchedDocuments();
			}
		},
		onToDateSelect(date){
			this.endDate = date;
			if(this.startDate !== null && this.startDate !== ""){
				this.getDatesForCustomerBatchedDocuments();
			}
		},
		downloadSelectedBatches(){
			console.log("selectedDocumentBatchDates", this.selectedDocumentBatchDates);
		},
		downloadSingleBatch(selectedDocument){
			// this.selectedDocumentBatchDates = [];
			// this.selectedDocumentBatchDates.push(document);
			// console.log("selectedDocumentBatchDates", this.selectedDocumentBatchDates);
			this.loading = true;
			let request = {
				pathToFileStorage: selectedDocument.pathInFileStorage,
				fileName: selectedDocument.name
			};
			orderService.downloadOrderDocument(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					const url = window.URL.createObjectURL(new Blob([successResponse.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', selectedDocument.name);
					document.body.appendChild(link);
					link.click();
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		errorMessageCloseClick(){
			this.showErrorMessage = false;
		},
		onSuccessMessageCloseClick(){
			this.showSuccessMessage = false;
		},
		onModalCloseClick(){
			console.log("close clicked");
			this.showErrorMessage = false;
			this.showSuccessMessage = false;
			this.$emit("closeModal");
		}
	},
	mounted: function () {
		
	},
	watch: {
		heading: {
			handler: function () {
				if (this.heading) {
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId: {
			handler: function () {
				if (this.modalId) {
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal: {
			handler: function () {
				console.log("showModal", this.showModal);
				console.log("modalComponentId", this.modalComponentId);
				this.startDate = null;
				this.endDate = null;
				this.documents = [];
				if (this.showModal) {
					//$("#" + this.modalId).modal("show");
					$("#" + this.modalComponentId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				} else {
					$("#" + this.modalComponentId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};